
import axios from "axios";
import config from "../resources/Config"


export const validateZipcodeService = 
             async({ zipcode, division, unit, consumption }) => 
             await axios.get(`${config.flatgas.validationUrl}?consumption=${consumption}&division=${division}&unit=${unit}&zipcode=${zipcode}`);
 